import { render, staticRenderFns } from "./FreightTerms.vue?vue&type=template&id=6a33a71a&scoped=true"
import script from "./FreightTerms.vue?vue&type=script&lang=js"
export * from "./FreightTerms.vue?vue&type=script&lang=js"
import style0 from "./FreightTerms.vue?vue&type=style&index=0&id=6a33a71a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a33a71a",
  null
  
)

export default component.exports